// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add these styles to your CSS file */
.delete-btn {
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
  
  /* Custom pop-up styles */
  .custom-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .custom-popup h2 {
    margin-top: 0;
  }
  
  .custom-popup-buttons {
    margin-top: 20px;
    text-align: right;
  }
  
  .custom-popup-buttons button {
    margin-left: 10px;
  }
  /* Add these styles to your CSS file */
.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .update-btn {
    background-color: blue;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
  
  .delete-btn {
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
  
  /* Custom pop-up styles */
  .custom-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .custom-popup h2 {
    margin-top: 0;
  }
  
  .custom-popup-buttons {
    margin-top: 20px;
    text-align: right;
  }
  
  .custom-popup-buttons button {
    margin-left: 10px;
  }
  
  /* Add space between buttons */
  .button-space {
    margin: 0 6px;
  }
  /* Add these styles to your CSS file */
.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .update-btn {
    background-color: blue;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
  
  .delete-btn {
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
  }
  
  /* Custom pop-up styles */
  .custom-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .custom-popup h2 {
    margin-top: 0;
  }
  
  .custom-popup-buttons {
    margin-top: 20px;
    text-align: right;
  }
  
  .custom-popup-buttons button {
    margin-left: 10px;
  }
  
  /* Add space between buttons */
  .button-space {
    margin: 0 4px;
  }
/* Add these styles to your CSS file */
.custom-popup-buttons button {
    margin-left: 10px;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .custom-popup-buttons button.cancel-btn {
    background-color: #ccc;
    color: #333;
  }
  
  .custom-popup-buttons button.delete-btn {
    background-color: red;
    color: white;
  }
    `, "",{"version":3,"sources":["webpack://./src/dashboard/AdminDashboard/pages/UserCampign2/UserCampign2.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA,sCAAsC;AACxC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;EACf;EACA,sCAAsC;AACxC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;EACf;AACF,sCAAsC;AACtC;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd","sourcesContent":["/* Add these styles to your CSS file */\r\n.delete-btn {\r\n    background-color: red;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Custom pop-up styles */\r\n  .custom-popup {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: white;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .custom-popup h2 {\r\n    margin-top: 0;\r\n  }\r\n  \r\n  .custom-popup-buttons {\r\n    margin-top: 20px;\r\n    text-align: right;\r\n  }\r\n  \r\n  .custom-popup-buttons button {\r\n    margin-left: 10px;\r\n  }\r\n  /* Add these styles to your CSS file */\r\n.button-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .update-btn {\r\n    background-color: blue;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .delete-btn {\r\n    background-color: red;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Custom pop-up styles */\r\n  .custom-popup {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: white;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .custom-popup h2 {\r\n    margin-top: 0;\r\n  }\r\n  \r\n  .custom-popup-buttons {\r\n    margin-top: 20px;\r\n    text-align: right;\r\n  }\r\n  \r\n  .custom-popup-buttons button {\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  /* Add space between buttons */\r\n  .button-space {\r\n    margin: 0 6px;\r\n  }\r\n  /* Add these styles to your CSS file */\r\n.button-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .update-btn {\r\n    background-color: blue;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .delete-btn {\r\n    background-color: red;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Custom pop-up styles */\r\n  .custom-popup {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: white;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .custom-popup h2 {\r\n    margin-top: 0;\r\n  }\r\n  \r\n  .custom-popup-buttons {\r\n    margin-top: 20px;\r\n    text-align: right;\r\n  }\r\n  \r\n  .custom-popup-buttons button {\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  /* Add space between buttons */\r\n  .button-space {\r\n    margin: 0 4px;\r\n  }\r\n/* Add these styles to your CSS file */\r\n.custom-popup-buttons button {\r\n    margin-left: 10px;\r\n    padding: 8px 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .custom-popup-buttons button.cancel-btn {\r\n    background-color: #ccc;\r\n    color: #333;\r\n  }\r\n  \r\n  .custom-popup-buttons button.delete-btn {\r\n    background-color: red;\r\n    color: white;\r\n  }\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
